import { render } from "./ManageEditBoxes.vue?vue&type=template&id=62a48ea0"
import script from "./ManageEditBoxes.vue?vue&type=script&lang=js"
export * from "./ManageEditBoxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__